import { courier } from 'src/constants/purchaseOrderFormFields';
import { jobsheetTatActions } from './actionTypes';

export interface jobsheetTatReducerState {
  loading: boolean;
  error: string;
  message: string;
  courierTypeOptions: any;
}

const initialState: jobsheetTatReducerState = {
  loading: false,
  error: "",
  message: "",
  courierTypeOptions: []
}


const jobsheetTatReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case jobsheetTatActions.DOWNLOAD_JOB_PREFIX_EXCEL_LOADING:
      return {
        ...state,
        loading: true,
        error: "",
        message: ""
      }

    case jobsheetTatActions.DOWNLOAD_JOB_PREFIX_EXCEL_SUCCESS:

      return {
        ...state,
        loading: false,
        message: "Mail send successfully"
      }

    case jobsheetTatActions.JOBSHEET_TAT_CLEAR:

      return {
        ...state,
        loading: false,
        message: "",
      }
    case jobsheetTatActions.GET_JOBSHEET_COURIER_OPTION_SUCCESS:

      return {
        ...state,
        loading: false,
        courierTypeOptions: action.payload?.data
      }

    case jobsheetTatActions.DOWNLOAD_JOB_PREFIX_EXCEL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return { ...state }
  }
}

export default jobsheetTatReducer;